import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { combinedStorage } from 'utils/combinedStorage'
import { TOKEN_KEY } from 'redux/constant/user'

const INVITE_CODE_KEY = 'invited_by'
const APKENC_KEY = 'apkenc'

interface UserInfo {
  name: string
  id: string
}

interface TokenInfo {
  [key: string]: unknown
}

interface UserState {
  userInfo: UserInfo
  tokenInfo: TokenInfo
  inviteCode: string | null
  apkenc: string | null
  isTempLogin: boolean
}

const initialState: UserState = {
  userInfo: {
    name: '',
    id: '',
  },
  /** Token 資訊 */
  tokenInfo: {},
  /** 代理邀請碼 */
  inviteCode: combinedStorage.getItem(INVITE_CODE_KEY) ?? null,
  apkenc: combinedStorage.getItem(APKENC_KEY) ?? null,
  isTempLogin: false,
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<UserInfo>) => {
      state.userInfo = action.payload
    },
    clearUser: (state, action: PayloadAction<void>) => {
      state.userInfo = initialState.userInfo
      localStorage.removeItem(TOKEN_KEY)
    },
    updateTokenInfo: (state, action: PayloadAction<TokenInfo>) => {
      state.tokenInfo = action.payload
      localStorage.setItem(TOKEN_KEY, JSON.stringify(action.payload))
    },
    updateTokenInfoWithoutPersist: (state, action: PayloadAction<TokenInfo>) => {
      state.tokenInfo = action.payload
      sessionStorage.setItem(TOKEN_KEY, JSON.stringify(action.payload))
    },
    updateInviteCode: (state, action: PayloadAction<string>) => {
      combinedStorage.setItem(INVITE_CODE_KEY, action.payload)
      state.inviteCode = action.payload
    },
    updateApkenc: (state, action: PayloadAction<string>) => {
      combinedStorage.setItem(APKENC_KEY, action.payload)
      state.apkenc = action.payload
    },
    updateIsTempLogin: (state, action: PayloadAction<boolean>) => {
      state.isTempLogin = action.payload
    },
  },
})

export const { actions } = slice
export default slice.reducer
